/**
 * Homepage mobile — Shop by Category first, hero slideshow second (Mamaearth-style).
 * Desktop DOM order restored on wider viewports.
 */

(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  /** @returns {{ main: HTMLElement, category: HTMLElement | null, hero: HTMLElement | null } | null} */
  function getSections() {
    const main = document.getElementById('MainContent');
    if (!(main instanceof HTMLElement)) return null;

    const category = main.querySelector('.shopify-section:has(#shop-by-category)');
    const hero = main.querySelector('.shopify-section:has(> .slideshow-section)');

    return {
      main,
      category: category instanceof HTMLElement ? category : null,
      hero: hero instanceof HTMLElement ? hero : null,
    };
  }

  /** @returns {boolean} */
  function isMobileOrderApplied(sections) {
    return sections.category.nextElementSibling === sections.hero;
  }

  /** @returns {boolean} */
  function isDesktopOrderApplied(sections) {
    return sections.hero.nextElementSibling === sections.category;
  }

  function applyMobileOrder() {
    const sections = getSections();
    if (!sections?.category || !sections.hero) return;
    if (isMobileOrderApplied(sections)) return;

    sections.main.insertBefore(sections.category, sections.hero);
  }

  function restoreDesktopOrder() {
    const sections = getSections();
    if (!sections?.category || !sections.hero) return;
    if (isDesktopOrderApplied(sections)) return;

    sections.main.insertBefore(sections.hero, sections.category);
  }

  function syncHomepageSectionOrder() {
    if (!document.body.classList.contains('template-index')) return;

    if (MOBILE_MQ.matches) {
      applyMobileOrder();
    } else {
      restoreDesktopOrder();
    }
  }

  function init() {
    syncHomepageSectionOrder();
    MOBILE_MQ.addEventListener('change', syncHomepageSectionOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
